import React from 'react'
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';
import CalendarView from '../../components/staffDutyRosterComponents/CalenderView'

const StaffDutyRoster = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Staff'));
    return <CalendarView />
}

export default StaffDutyRoster